<template>
  <v-container grid-list-lg class="pa-0" fill-height>
    <v-layout row wrap>
      <v-flex md8>
        <v-card>
          <v-card-title class="grey lighten-4">
            <span class="title primary--text">Highlights</span>
          </v-card-title>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex sm6>
                <v-icon large>assistant</v-icon>
                <span class="display-2 secondary--text">{{dashboard.skills}}</span>
                <span class="subheading primary--text"> skills</span>
              </v-flex>
              <v-flex sm6>
                <v-icon large>work</v-icon>
                <span class="display-2 secondary--text">{{dashboard.packages}}</span>
                <span class="subheading primary--text"> packages</span>
              </v-flex>
              <v-flex sm6>
                <v-icon large>school</v-icon>
                <span class="display-2 secondary--text">{{dashboard.yoe}}</span>
                <span class="subheading primary--text"> years experience</span>
              </v-flex>
              <v-flex sm6>
                <v-icon large>date_range</v-icon>
                <span class="display-2 secondary--text">{{dashboard.busyDays}}</span>
                <span class="subheading primary--text"> busy days this month</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-card class="my-3">
          <v-card-title class="grey lighten-4 py-1">
            <span class="title primary--text">Profile Completion</span>
            <v-spacer></v-spacer>
            <v-btn round color="primary" small to="/profile">Update Profile</v-btn>
          </v-card-title>
          <v-card-text>
            <v-layout row>
              <v-flex xs10><v-progress-linear :value="completion"  color="primary" height="1.5em">
                </v-progress-linear>
              </v-flex>
              <v-flex xs2>
                <span class="secondary--text display-2">{{completion}}%</span>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title class="grey lighten-4">
            <span class="title primary--text">Quick Links</span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap justify-space-around>
              <v-btn outline color="primary" to="/packages" round small><v-icon left>library_add</v-icon>Add a Package</v-btn>
              <v-btn outline color="primary" to="/calendar" round small><v-icon left >calendar_today</v-icon> My Important Dates</v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md4><trending-packages></trending-packages></v-flex>
    </v-layout>
    <!-- row 1: Highlights and Completion -->
    <!-- <v-layout row wrap> -->
      <!-- start Highlights -->
      <!-- <v-flex sm6>
        <v-card class="row1-card-height">
          <v-container fluid grid-list-sm>
            <v-flex xs12 class="headline">
              Highlights:
            </v-flex>
            <v-layout row justify-space-between class="ml-3">
              <v-flex class="blue--text">
                <span class="display-2">{{dashboard.skills}}</span>
                <span class="subheading"> skills</span>
              </v-flex>
              <v-flex class="red--text">
                <span class="display-2">{{dashboard.packages}}</span>
                <span class="subheading"> packages</span>
              </v-flex>
              <v-flex class="green--text">
                <span class="display-2">{{dashboard.yoe}}</span>
                <span class="subheading"> years experience</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex> -->
      <!-- end Highlights -->
      <!-- start Completion -->
      <!-- <v-flex sm6>
        <v-card class="row1-card-height">
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12 class="headline">
                Profile Completion:
                <v-btn round small color="warning" to="/profile" dark>Complete your profile now!</v-btn>
              </v-flex>
              <v-flex xs10>
                <v-progress-linear :value="completion" height="20" :color="progress.barColor"></v-progress-linear>
              </v-flex>
              <v-flex xs2>
                <span class="display-1" :class="progress.textColor">{{completion}}%</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex> -->
      <!-- end completion -->
    <!-- </v-layout> -->
    <!-- end row 1 -->
    <!-- row 2: Recommended Packages -->
    <!-- end row 2 -->
    <!-- row 3: Quick Links -->
    <!-- <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-container fluid grid-list-sm>
            <div class="headline pl-2">
              Quick Links:
            </div>
            <v-layout row wrap justify-space-around>
              <!-- <recommend-to-friend-card></recommend-to-friend-card> -->
              <!-- <v-btn flat color="primary"><v-icon left>group</v-icon> Recommended a friend</v-btn> -->
              <!-- <v-btn flat color="primary" to="/packages"><v-icon left>library_add</v-icon> Add a Package</v-btn>
              <v-btn flat color="primary" to="/calendar"><v-icon left>calendar_today</v-icon> My Important Dates</v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout> -->
    <!-- end row 3 -->
  </v-container>
</template>
<script>
/* globals Store */
import TrendingPackages from '@/components/TrendingPackages'
import { mapState } from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    TrendingPackages
  },
  data () {
    return {
      headers: [
        { text: 'Packages', value: 'package' },
        { text: 'Audience', value: 'audience' },
        { text: 'Skills', value: 'skills' },
        { text: 'Trainers selling this package', value: 'sales', align: 'right' }
      ],
      packages: [
        { package: 'Time Management', audience: 'Managers', skills: 'Productivity', sales: 20 },
        { package: 'Critical Communication', audience: 'Managers', skills: 'Negotiation', sales: 34 },
        { package: 'Effective English', audience: 'Entry Level', skills: 'Language', sales: 24 },
        { package: 'Table Etiquites', audience: 'Entry Level', skills: 'Soft skill', sales: 107 }
      ]
    }
  },
  computed: {
    ...mapState('user', {
      dashboard: 'dashboard',
      completion: 'completion'
    })
  },
  mounted () {
    Store.dispatch('user/getDashboard')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue